import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { DragDropContext, Droppable, DropResult } from 'react-beautiful-dnd';
import { Button, Checkbox, Grid, Modal, Segment } from 'semantic-ui-react';
import { store, useStore } from '../../app/stores/store';

interface props {
  closeModalHandler?: (checkedItems: string[]) => void;
}

function ReportsModalForMetaData({ closeModalHandler }: props) {
  const { dashboardStore, reportStore } = useStore();
  const [, setOpen] = useState<any>(true);
  const [checkedItems, setCheckedItems] = useState<any>([]);
  const [toggleObjValue, setToggleObjValue] = useState<any>([]);
  const [mainData, setMainData] = useState<any>(
    reportStore.metaDataNoPaginationReport,
  );
  const [, setSubTaskElements] = useState<any[] | undefined>();

  useEffect(() => {
    const name = reportStore.metaDataNoPaginationReport.map((item: any) => {
      return item.replaceAll(/vault/gi, 'Room');
    });
    if (store.userStore.user?.customerName === 'LVP CMS - AM') {
      reportStore.metaDataNoPaginationReport = name;
    }
    reportStore.metaDataNoPaginationReport =
      reportStore.metaDataNoPaginationReport.filter(
        (e) =>
          e !== 'year' &&
          e !== 'language' &&
          e !== 'originindia' &&
          e !== 'synopsis',
      );
    setMainData(reportStore.metaDataNoPaginationReport);
    // eslint-disable-next-line
  }, [JSON.stringify(reportStore.metaDataNoPaginationReport)]);

  useEffect(() => {
    const getCheckedItems: any = localStorage.getItem(
      dashboardStore.dashboard.tableName,
    );
    // if(getCheckedItems !== undefined && getCheckedItems !== null) {
    dashboardStore.setHeaderTable(getCheckedItems);
    const ArrayFormat = getCheckedItems.split(',');
    const actualArr = ArrayFormat;
    const filteredArr = actualArr.filter(
      (item: any, index: any, self: any) => self.indexOf(item) === index,
    );

    setToggleObjValue(filteredArr);
    setCheckedItems(actualArr);
    // }
    // localStorage.removeItem(dashboardStore.dashboard.tableName)
  }, [dashboardStore]);
  const test = (e: any) => {
    const currTrgt: any = e.currentTarget.attributes['toggleName'].value;
    if (e.currentTarget.children[0].checked === false) {
      setCheckedItems([...checkedItems, currTrgt]);
    } else {
      setCheckedItems(
        checkedItems.filter(
          (item: any) => item.toLowerCase() !== currTrgt.toLowerCase(),
        ),
      );
    }
  };

  const setOpenModal = () => {
    closeModalHandler?.(checkedItems);
    let items = checkedItems?.flatMap((data: string) =>
      data !== 'id' ? data : [],
    );
    localStorage.setItem(dashboardStore.dashboard.tableName, items);
    dashboardStore.reportsConfigurationOpen(false);
  };

  const onDragEnd = (result: DropResult) => {
    const { source, destination } = result;
    if (!destination) return;
    const items = Array.from(dashboardStore.dashboard.headerTable);
    const [newOrder] = items.splice(source.index, 1);
    items.splice(destination.index, 0, newOrder);
    setSubTaskElements(items);
    const dragandDrop = destination.index.toString();
    localStorage.setItem('drag', dragandDrop);
    const getCheckedItemss: any = localStorage.getItem('drag');
    dashboardStore.setDrag(getCheckedItemss);
  };

  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={dashboardStore.dashboard.reportsConfiguration}
    >
      <Modal.Header>{dashboardStore.dashboard.tableName}</Modal.Header>
      <Segment style={{ height: '70vh' }}>
        <DragDropContext onDragEnd={onDragEnd}>
          <Droppable droppableId="droppable">
            {(provided) => (
              <div
                className="templatepreset workflow-config-elements"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                <Grid columns={3}>
                  {toggleObjValue?.length !== 0 &&
                    mainData?.map((dat: any, index: number) => {
                      dashboardStore?.setFinalValue(
                        toggleObjValue?.includes(dat),
                      );
                      return (
                        <>
                          {dat !== 'id' &&
                          dat !== 'title' &&
                          dat !== 'isdeleted' &&
                          dat !== 'isreceiving' ? (
                            <Grid.Column
                              style={{
                                color: 'black',
                              }}
                            >
                              <Grid columns={2}>
                                <Grid.Row>
                                  <Grid.Column width={10}>
                                    {dat?.charAt(0)?.toUpperCase() +
                                      dat?.slice(1)?.split('_').join(' ')}
                                  </Grid.Column>
                                  <Grid.Column width={6}>
                                    <Checkbox
                                      key={index}
                                      toggleName={dat}
                                      onClick={(e: any) => {
                                        test(e);
                                      }}
                                      toggle
                                      defaultChecked={
                                        toggleObjValue.includes(dat)
                                          ? true
                                          : false
                                      }
                                      style={{
                                        marginTop: '5px',
                                      }}
                                    />
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                            </Grid.Column>
                          ) : null}
                        </>
                      );
                    })}
                </Grid>
              </div>
            )}
          </Droppable>
        </DragDropContext>
      </Segment>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => dashboardStore.reportsConfigurationOpen(false)}
        >
          Cancel
        </Button>
        <Button
          content="Submit"
          labelPosition="right"
          icon="checkmark"
          onClick={setOpenModal}
          positive
        />
      </Modal.Actions>
    </Modal>
  );
}
export default observer(ReportsModalForMetaData);
